import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setBreadcrumbs, setCreateButton, setSearchHandler, setTitle} from "../actions/main";
import {Link, useNavigate} from "react-router-dom";
import {UsersService} from "../services/UsersService";
import {userService as UserService} from "../services/UserService";
import TableView from "../components/TableView";
import Formatter from "../helpers/formater";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import Total from "../components/Total";

function Departments() {

    const [data, setData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(false)
    const [filter, setFilter] = useState({filter: {}});
    const [navOptions, setNavOptions] = useState([
        {query: 'kindergarten', label: 'Сады', count: 0},
        {query: 'school', label: 'Школы', count: 0},
    ])

    let storageColumns = localStorage.getItem('table-departments-list'),
        defaultColumns = [
            {name: 'name', label: 'Наименование', selected: true},
            {name: 'email', label: 'Email', selected: true},
            {name: 'phone', label: 'Телефон', selected: true},
        ];
    if(storageColumns){
        defaultColumns = JSON.parse(storageColumns)
    }

    const [tableRows, setTableRows] = useState(defaultColumns)

    const userData = useSelector(function (state) {
        return state.auth.userData
    });
    const searchString = useSelector((s) => s.searchString) || ''
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(setTitle('Филиалы'))
        dispatch(setCreateButton('/departments/create'))
        dispatch(setSearchHandler(false))
        dispatch(setBreadcrumbs([
            {link: 'departments', label: 'Филиалы'}
        ]))
    })

    let navigation = useNavigate();


    function updateData(params) {

        UserService.GetAllDepartments().then((response, h) => {

            if (response.items) {
                setData(response)
                setLoading(false)
            } else {
                // toast.current.show({severity:'error', summary: 'Ошибка', detail:'Не удалось загрузить данные.', life: 3000});
            }
        })
    }

    function setTableRowsHandler(data) {
        setTableRows(data)
    }

    function handleEditItem(id) {
        navigation(`/departments/${id}`)
    }


    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-user-edit',
            command:(e) => {
                navigation('/departments/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этот филиал?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {

                    },
                    acceptLabel: 'Да',
                    reject: () => {return false},
                    rejectLabel: 'Нет'
                });
            }
        }
    ];


    const handlerRawActions = (elId) => {
        const currentRow = data.items.find((el) => {
            return el.id === elId
        })

        if(currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId
            })

            return rowActions;
        }
    }

    const tableValue = (propName, el) => {
        switch (propName) {

            case 'name': {
                return (
                    <Link to={'/departments/' + el.id} className="d-flex align-items-center">
                        <span>{el.name}</span>
                    </Link>
                )
            }
            default:
                return (
                    el[propName]
                )
        }
    }

    const handlePageClick = (event) => {
        setLoading(true);
        updateData({...filter, page: ++event.selected})
    }

    useEffect(() => {
        updateData()
    }, []);

    return (
        <div className={'product-wrapper'}>
            <div className={'card'}>


                <div className="card-body p-0">

                    <ConfirmDialog/>


                    <TableView id={'user-list'} tableRows={tableRows} data={data} tableValue={tableValue} loading={loading}
                               setTableRows={setTableRowsHandler} handleEdit={handleEditItem} rowActions={rowActions} massRowActions={false} massActionHander={false} rowActionsHandler={handlerRawActions} tableClass={'departments-table'}/>

                </div>

            </div>
            <Total data={data} handlePageClick={handlePageClick}/>
            {/*<Toast/>*/}
        </div>
    )
}

export default Departments